/* eslint-disable */
import { createSelector } from 'reselect';
import orderEntitiesSelector from './OrderEntities.selector';
import orderIdsSelector from './OrderIds.selector';

/**
 * Select the sorted orders
 * @returns {Array<OrderEntity>} The sorted `order`s that has been selected from the store
 */
const sortedOrdersSelector = createSelector(
  orderEntitiesSelector,
  orderIdsSelector,
  (entities, ids) => ids.map((id) => entities[id]),
);

export default sortedOrdersSelector;
